import { useEffect } from "react";
import { useHistory } from "react-router";
// Components

// Images
import salesBanner from '../../assets/img/partnerPortal/sales/Half Wave.svg';
import email from '../../assets/img/general/email.svg';
import arrowButton from '../../assets/img/partnerPortal/homepage/arrow-right-white.png';

// Scss
import '../../assets/css/partnerProgram.scss';
import '../../assets/css/partnerPortal/welcome.scss';



import Title from "../../components/Title";
import NewsSectionTwo from "../../components/NewsSectionTwo";

function RegistrationSuccess() {

  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();


  }, []);

    const TITLE = "Processing your registration...";
    const SUB_TITLE = <div>Your registration is currently being handled through automated processing. Should any issues arise, we will promptly inform you.
                            <br/><br/>Upon successful completion of the process (5-10 minutes), an email will be sent to you containing instructions to set up your password. This is unless you already possess credentials linked to the email you utilized for registration.<br/>
                            <br/>If this is the case, we kindly ask you to wait for 5-10 minutes and then attempt to log in to the portal using those specific credentials. These could be the same credentials you established to access, for instance, the Free Trial Tenant.
                            <br/>
                            <br/>

                            </div>;

  return (
    <>
        <div className="mb-3">
            <div className="d-flex flex-column align-items-center mb-3 w-100">
                <img src={salesBanner} className=' shadow-4 imageBannerSales' alt='...' />
                <div className="d-flex row w-100 marginsAssociate">
                    <div className="d-flex pt-4 flex-column align-items-start justify-content-center width42 mr-5">
                        <div className="d-flex align-items-start pb-4">
                            <Title classNameText="salesTitle" title={TITLE} withoutLine={true}/>
                        </div>
                        <div className="d-flex align-items-start">
                            <div className="subCopyLetters mb-3">
                                {SUB_TITLE}
                            </div>
                        </div>
                    </div>
                </div>
                <NewsSectionTwo title={"Did you never receive an email and you don't know your credentials?"} subTitle={<div>Wait 5-10 minutes after the registration, then follow the <a target="_blank" href="https://sso.dynatrace.com/#reset-password">link</a> to reset/setup your password.</div>} active={true} />
                <NewsSectionTwo title={"What can I access after the partner portal registration?"} subTitle={<div>  - <b>Partner portal:</b> This platform enables you to perform various tasks such as registering deals, enrolling in bootcamps, accessing enablement resources, launching marketing campaigns, and more.<br/>
                            - <b>Dynatrace university:</b> This hub allows you to schedule certification exams, access on-demand training sessions, and enhance your expertise.<br/>
                            - <b>Demo environment:</b>  Gain hands-on experience with Dynatrace by utilizing the demo environment, fostering active learning.<br/>
                            - <b>Dynatrace Community:</b> Engage with a community of observability enthusiasts, where you can discover solutions, pose inquiries, and collaborate with fellow experts to drive innovation.</div>} />
            </div>

        </div>
    </>
  );

  function canYouHaveAccess() {
    try {
      if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
        console.log("You shall not pass");
        history.push('/not-found');
      }
    } catch (err) {
      

    }
  }

}

export default RegistrationSuccess;

